import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import { unzipSync } from 'zlib';
import { connected } from 'process';
import format from 'date-fns/format'
export default {
    namespaced: true,
    state: {
        sparkHappily:[],
        sparkHappilyloading: false,
        sparkCustom:[],
        sparkStatus:false,
        cardId:'',
        customClass:[],
        sparkType:[]
    },
    mutations: {
        setSparkHappily(state: any, result: any) {
            state.sparkHappily = result
        },
        setSparkHappilyloading(state: any, result: any) {
            state.sparkHappilyloading = result
        },
        setSparkCustom(state: any, result: any) {
            state.sparkCustom = result
        },
        setSparkStatus(state: any, result: any) {
            state.sparkStatus = result
        },
        setCardId(state: any, result: any) {
            state.cardId = result
        },
        setCustomClass(state: any, result: any) {
            state.customClass = result
        },
        setSparkType(state: any, result: any) {
            state.sparkType = result
        },
    },
    actions: {
        async checkSetName({ commit, state }: any,{name,user}:any) {
            commit('setSparkStatus',false)

            await firebase.database().ref('spark_set').orderByChild('name').equalTo(name).once('value', (snapshot) => {
                snapshot.forEach((childSnapshot) => {
                    const data = childSnapshot.val();
                    if(data!='')
                    {
                        if(user.company===data.companyId||data.companyId===undefined)
                        {
                            commit('setSparkStatus',true)
                        }
                    }    
                })
            })
               
            },
        async getSparkHappily({ commit, state }: any,data:any) {
        const dataSparkSet:Array<any> = [];
        commit('setSparkHappilyloading', true);
        await firebase.database().ref('spark_set').once('value', (snapshot) => {
                snapshot.forEach((childSnapshot) => {
                    let cardList:Array<any> = [];
                    const _data = childSnapshot.val();
                    if(_data.companyId===undefined||_data.companyId===data.company)
                    {
                   
                    firebase.firestore().collection('spark_class').where("set", "==", childSnapshot.key).orderBy("order",'asc').get()
                    .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        const data = doc.data();
                        cardList.push({...data,sparkTitle:data.name,id:doc.id})
                    })})
                    dataSparkSet.push({
                        ..._data,
                        cardList,
                        customSet: _data.customSet===undefined?0:_data.customSet,
                        id:childSnapshot.key,
                        happilySet:_data.order===undefined?_data.happilySet:_data.order,
                        type:_data.companyId===undefined?'happily':'custom',
                        permissions: ["Everyone"],})
                    }
                })
            })
             const sort_List = _.sortBy(dataSparkSet, ["happilySet", "customSet"]);
            commit('setSparkHappilyloading', false);
            commit('setSparkHappily', sort_List)
           
        },
        async getSparkCustom({ commit, state }: any,data:any) {
            const dataSparkSetCustom:Array<any> = [];
           await firebase.database().ref('spark_set').orderByChild('companyId').equalTo(data.company).once('value', (snapshot) => {
                    snapshot.forEach((childSnapshot) => {
                        const cardList:Array<any> = [];
                        const _data = childSnapshot.val(); 
                            firebase.firestore().collection('spark_class').where("set", "==", childSnapshot.key).orderBy("order",'asc').get()
                            .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                // console.log("data",data)
                                cardList.push({...data,sparkTitle:data.name,id:doc.id})
                            })})
                            dataSparkSetCustom.push({
                                ..._data,
                                cardList,
                                customSet: _data.customSet===undefined?0:_data.customSet,
                                id:childSnapshot.key,
                                happilySet:_data.order===undefined?_data.happilySet:_data.order,
                                type:_data.companyId===undefined?'happily':'custom',
                                permissions: ["Everyone"],}) 
                        })
                    
                })
       
                commit('setSparkCustom', dataSparkSetCustom)
               
            },
        async createSparkSetCustom({ commit, state }: any,data:any){
                firebase.database().ref("spark_set").push(data)
        },
        async updateSetNameSparkCustom({ commit, state,dispatch, rootState}: any,{data,user}:any){
            commit('setSparkStatus',false)
            await firebase.database().ref('spark_set').orderByChild('name').equalTo(data.name).once('value', (snapshot) => {
                snapshot.forEach((childSnapshot) => {
                    const data = childSnapshot.val();
                    if(data!='')
                    {
                        if(user.company===data.companyId||data.companyId===undefined)
                        {
                            commit('setSparkStatus',true)
                        }
                    }    
                })
            })
            if(!state.sparkStatus)
            {
                await firebase.database().ref(`spark_set/${data.id}`).update({name:data.name});
                 /*save logs*/
                 dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: data.id,
                    table: 'spark_set',
                    status: 'update',
                    user: rootState.authen.user.email
                }, {root:true})
                commit('setSparkStatus',false)
            }
           
        },
        async updatePositionsSparkCustom({ commit, state ,dispatch,rootState}: any,data:any){ 
            await firebase.database().ref(`spark_set/${data.id}`).update({customSet: data.customSet,happilySet: data.happilySet}).then(()=>{
                 /*save logs*/
                 dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: data.id,
                    table: 'spark_set',
                    status: 'update',
                    user: rootState.authen.user.email
                }, {root:true})
            });

        },
        async updateSparkCustom({ commit, state,dispatch,rootState }: any,data:any){  
                await firebase.database().ref(`spark_set/${data.id}`).update(data).then(()=>{
                /*save logs*/
                    dispatch('authen/addLogs', {
                        company: rootState.authen.user.company,
                        createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                        id: data.id,
                        table: 'spark_set',
                        status: 'update',
                        user: rootState.authen.user.email
                    }, {root:true})
                });

        },
        deleteSparkCustom({ commit, state,rootState,dispatch }: any,data:any){  
            firebase.database().ref(`spark_set/${data.id}`).remove().then(()=>{
                /*save logs*/
                dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: data.id,
                    table: 'spark_set',
                    status: 'delete',
                    user: rootState.authen.user.email
                }, {root:true})
            })
            firebase.firestore().collection("spark_class").where('set', '==', data.id).get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                  doc.ref.delete();
                });
                 /*save logs*/
                 dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: data.id,
                    table: 'spark_class',
                    status: 'delete',
                    user: rootState.authen.user.email
                }, {root:true})
              });
        },
        deleteSparkCustomClass({ commit, state ,rootState,dispatch}: any,data:any){  
             firebase.firestore().collection("spark_class").doc(data.id).delete().then(() => {
               /*save logs*/
               dispatch('authen/addLogs', {
                company: rootState.authen.user.company,
                createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                id: data.id,
                table: 'spark_class',
                status: 'delete',
                user: rootState.authen.user.email
            }, {root:true})
            })
        },
        async createSparkCustomClass({ commit, state }: any,data:any){  
           await firebase.firestore().collection("spark_class").add(data).then((docRef) => {
               
                commit('setCardId', docRef.id)
                
            })
        },
        updateSpartCustomClass({ commit, state ,dispatch,rootState}: any,{id,data}:any){  
            firebase.firestore().collection(`spark_class`).doc(id).update(data).then(()=>{
                /*save logs*/
                dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: data.id,
                    table: 'spark_class',
                    status: 'update',
                    user: rootState.authen.user.email
                }, {root:true})
            })
        },
        async getSparkType({ commit, state }: any) {
            const dataSparkType:Array<any> = [];
            await firebase.database().ref('spark_type').once('value', (snapshot) => {
                    snapshot.forEach((childSnapshot) => {
                        const _data = childSnapshot.val();
                        if(_data.image!==undefined)
                        {
                            dataSparkType.push({..._data,id:childSnapshot.key})
                        }
                    })
                })
                commit('setSparkType', dataSparkType)
               
        },
    },
    getters: {
        sparkHappily:(state: any) => {
            return state.sparkHappily
        },
        sparkHappilyloading:(state: any) => {
            return state.sparkHappilyloading
        },
        sparkCustom:(state: any) => {
            return state.sparkCustom
        },
        sparkStatus(state: any, result: any) {
            return state.sparkStatus
        },
        cardId(state: any, result: any) {
            return state.cardId
        },
        customClass(state: any, result: any) {
            return state.customClass
        },
        sparkType:(state: any) => {
            return state.sparkType
        },

    }
}